import { queryStringify } from '@utils'
import { createRequestHelper } from '@utils/swr'
import { type FastpassPaymentRequest } from '../types/apiRequest'
import { type FastpassPaymentResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const { useRequest } = createRequestHelper<FortuneApis['get']['payment'], FastpassPaymentResponse, FastpassPaymentRequest>({
  client: 'fortune',
  key: (params) => {
    if (!params) return null
    const { order_type, payment_method_id, order_id } = params
    if (!order_type || !payment_method_id || !order_id) return null
    return `/payment/payment?${queryStringify(params, { skipNull: true })}`
  },
  fetcher: client => (url, params) => client.get(`${url}?${queryStringify(params || {})}`),
})

export const useApiFpPayment = useRequest
